const ONE_HUNDRED_EIGHTY = 180;
const RADIUS_OF_EARTH_IN_METERS = 6378137;
const DISTANCE = 20000;
const MAX_CAROUSEL_ITEMS = 5;
const MIN_CAROUSEL_ITEMS = 2;

export const propertyOffersComponent = {
	bindings: {
	},
	templateUrl: 'property-offers.html',
	transclude: true,
	controller: class propertyOffersComponent {
		constructor(SearchService, WebWalkService, $timeout, $scope, $rootScope, favouriteService, $filter) {
			'ngInject';
			this.carouselOffers = {};
			this.searchService = SearchService;
			this.webWalk = WebWalkService;
			this.$timeout = $timeout;
			this.$scope = $scope;
			this.$rootScope = $rootScope;
			this.favouriteService = favouriteService;
			this.$filter = $filter;
		}

		$onInit() {
			if (window.groups) {
				this.showGroupOffers = true;
			} else if (Array.isArray(window.manual)) {
				this.getManualOffers(window.manual);
			} else {
				this.carouselOffers = {
					show: false
				};
				this.watchLocationStatus();
			}
		}

		watchLocationStatus() {
			navigator.geolocation.getCurrentPosition((position) => {
				this.position = position;
				this.createAutomaticOffer(this.position.coords.latitude, this.position.coords.longitude);
			},
			() => {
				if (!this.loadedAutomatic) {
					this.automaticFromGeoIp();
				}
			}, {
				enableHighAccuracy: true,
				timeout: 10000,
				maximumAge: 0
			});
		}

		automaticFromGeoIp() {
			this.loadedAutomatic = true;
			this.searchService.getFreeGeoIp().then((response) => {
				this.createAutomaticOffer(response.data.latitude, response.data.longitude);
			});
		}

		createAutomaticOffer(latitude, longitude) {
			let locationParam = this.createLocationCoordinates(latitude, longitude, DISTANCE);
			let params = {
				location: locationParam,
				conditionOfProperty: 'newlyBuilt',
				locationTypes: 'MAPS'
			};
			this.searchService.searchProperty(params).then((response) => {
				if (response.data.hits.content.length > MAX_CAROUSEL_ITEMS || response.data.hits.content.length < MIN_CAROUSEL_ITEMS) {
					if (response.data.hits.content.length > MAX_CAROUSEL_ITEMS) {
						this.carouselOffers.offers = [];
						this.getRandomProperties(response);
						this.webWalk.setWebWalkProperty(this.carouselOffers.offers);
						this.orderPictures(this.carouselOffers.offers);
						this.carouselOffers.show = true;
					} else {
						// IP szerint ilyen nem lehetéges
						this.noOffers = true;
					}
				} else {
					this.carouselOffers.offers = response.data.hits.content;
					this.webWalk.setWebWalkProperty(this.carouselOffers.offers);
					this.orderPictures(this.carouselOffers.offers);
					this.carouselOffers.show = true;
				}
			}).catch(() => {
				// elcsattant az automatikus kérés, az egész blokkot nem kellene megjeleníteni
				this.noOffers = true;
			});
		}

		createLocationCoordinates(originalLat, originalLng, distance) {
			return this.addMetersToLat(originalLat, distance) + ',' + this.addMetersToLng(originalLat, originalLng, -1 * distance) +
				',' + this.addMetersToLat(originalLat, -1 * distance) + ',' + this.addMetersToLng(originalLat, originalLng, distance);
		}

		addMetersToLat(lat, meter) {
			return lat + ONE_HUNDRED_EIGHTY / Math.PI * (meter / RADIUS_OF_EARTH_IN_METERS);
		}

		addMetersToLng(lat, lng, meter) {
			return lng + ONE_HUNDRED_EIGHTY / Math.PI * (meter / RADIUS_OF_EARTH_IN_METERS) / Math.cos(lat);
		}

		getManualOffers(ids) {
			this.carouselOffers = {};
			let params = {
				comissionId: ids.join('|'),
				locationTypes: 'MAPS'
			};
			this.searchService.searchProperty(params).then((response) => {
				if (response.data.hits.content.length > MAX_CAROUSEL_ITEMS || response.data.hits.content.length < MIN_CAROUSEL_ITEMS) {
					if (response.data.hits.content.length > MAX_CAROUSEL_ITEMS) {
						this.carouselOffers.offers = [];
						this.getRandomProperties(response);
						this.webWalk.setWebWalkProperty(this.carouselOffers.offers);
						this.orderPictures(this.carouselOffers.offers);
						this.carouselOffers.show = true;
					} else {
						// init automatic offers
						this.watchLocationStatus();
					}
				} else {
					this.carouselOffers.offers = response.data.hits.content;
					this.webWalk.setWebWalkProperty(this.carouselOffers.offers);
					this.orderPictures(this.carouselOffers.offers);
					this.carouselOffers.show = true;
				}
			}).catch(() => {
				// init automatic offers
				this.watchLocationStatus();
			});
		}

		getRandomProperties(response) {
			let randIndex = '';
			let baseArray = response.data.hits.content;
			for (let i = 0; i < MAX_CAROUSEL_ITEMS; i++) {
				randIndex = Math.floor(Math.random() * baseArray.length);
				this.carouselOffers.offers.push(baseArray[randIndex]);
				baseArray.splice(randIndex, 1);
			}
		}

		orderPictures(properties) {
			if (Array.isArray(properties)) {
				properties.forEach(e => {
					e.images = this.$filter('picOrderFilter')(e.images);
				});
			}
		}

		navigateToProperty(property) {
			window.dataLayer.push({
				event: 'propertyListClick',
				propertyID: property.comissionId
			});
			window.location.href = property.url;
		}

		groupNavigation(title, link) {
			setTimeout(() => {
				window.location.href = link;
			}, 500);
		}

		/** Like */
		setLiked($event, item) {
			$event.preventDefault();
			$event.stopPropagation();
			window.dataLayer.push({
				event: 'propertyLike',
				propertyID: item.comissionId
			});
			this.item = item;
			this.favouriteService.setFavourite(this.item.comissionId).then(() => {
				this.item.liked = !this.item.liked;
			}).catch((error) => {
				console.log(error);
			});
		}
	}
};
